import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lisavalik

  <span style="color:#85c1dc;">**FI:**</span>
  Lisävalinta

  <span style="color:#85c1dc;">**RU:**</span>
  Вариация
*/
/* @__NO_SIDE_EFFECTS__ */
const m451 = msg(
  mf`Lisavalik`,
  mf`Lisävalinta`,
  mf`Вариация`,
)

export { m451 as 'w.module.options_section.variation' }